<ng-template #spinner>
   <mat-spinner diameter="30"></mat-spinner>
</ng-template>

<form [formGroup]="formGroup" (ngSubmit)="next()">
   <div>Select one of the following options to create a quote request.</div>
   <br/>

   <mat-radio-group formControlName="from">
      <mat-radio-button id="newQuoteRadioButton" [value]="'blank'">New Quote Request</mat-radio-button>

      <mat-radio-button id="templateRadioButton" #template [value]="'template'">From a Template</mat-radio-button>
      <ng-container *ngIf="template.checked">
         <mat-form-field *ngIf="templateService.getTemplates() | async as templates; else spinner">
            <mat-label>Template Name</mat-label>
            <mat-select id="templateSelect" required formControlName="templateId">
               <ng-container *ngFor="let template of templates; let last = last">
                  <mat-option id="templateOption" [value]="template.id" (click)="templateSelect(template)">
                     {{ template.name }}
                  </mat-option>
                  <mat-divider *ngIf="!last"></mat-divider>
               </ng-container>
            </mat-select>
         </mat-form-field>
         <mat-label class="template-desc">{{ templateDesc }}</mat-label>
      </ng-container>

      <mat-radio-button id="pastQuoteRadioButton" #pastQuote [value]="'past-quotation'">From a Past Quote Request</mat-radio-button>
      <ng-container *ngIf="pastQuote.checked">
         <form formGroupName="pastQuote">
            <mat-form-field class="common-w12ex">
               <!-- <mat-select required [formControl]="mode"> -->
               <mat-select id="pastQuoteSelect" formControlName="mode">
                  <mat-option id="copyOption" value="copy">Copy</mat-option><mat-divider></mat-divider>
                  <mat-option id="continueOption" value="continue">Continue</mat-option><mat-divider></mat-divider>
                  <mat-option id="reverseOption" value="reverse">Reverse</mat-option><mat-divider></mat-divider>
               </mat-select>
            </mat-form-field>

            <mat-form-field [hideRequiredMarker]="true">
               <mat-label>Quote Request #</mat-label>
               <!-- <input matInput required [formControl]="hawb" /> -->
               <input id="pastQuoteInput" matInput formControlName="number" />
            </mat-form-field>
         </form>
      </ng-container>

      <mat-radio-button id="pastShipmentRadioButton" #pastShip [value]="'past-shipment'">From a Past Shipment</mat-radio-button>
      <ng-container *ngIf="pastShip.checked">
         <form formGroupName="pastShip">
            <mat-form-field class="common-w12ex">
               <!-- <mat-select required [formControl]="mode"> -->
               <mat-select id="pastShipmentSelect" formControlName="mode">
                  <mat-option id="copyOption" value="copy">Copy</mat-option><mat-divider></mat-divider>
                  <mat-option id="continueOption" value="continue">Continue</mat-option><mat-divider></mat-divider>
                  <mat-option id="reverseOption" value="reverse">Reverse</mat-option><mat-divider></mat-divider>
               </mat-select>
            </mat-form-field>
   
            <mat-form-field [hideRequiredMarker]="true">
               <mat-label>HAWB</mat-label>
               <!-- <input matInput required [formControl]="hawb" /> -->
               <input  id="pastShipmentInput" matInput formControlName="number" />
            </mat-form-field>
         </form>
      </ng-container>
   </mat-radio-group>

   <!-- <div class="common-mt1em" *ngIf="!loading; else spinner">
      <button mat-raised-button color="primary" [disabled]="(template.checked && !templateId.value) || (pastShip.checked && !pastShipHawb.value) || (pastQuote.checked && !pastQuoteNumber.value)" type="submit">
        Create
      </button>
   </div> -->
</form>